export const MARKET_KEYS = ['fidc', 'fiagro', 'crs', 'fii'] as const;

export type MarketKey = (typeof MARKET_KEYS)[number];

const MARKET_ALIASES: Record<MarketKey, string[]> = {
  fidc: ['fidc'],
  fiagro: ['fiagro'],
  crs: ['crs', 'cr'],
  fii: ['fii'],
};

export function resolveMarketKey(marketParam?: string): MarketKey | null {
  if (!marketParam) {
    return null;
  }

  const normalized = marketParam.trim().toLowerCase();

  const match = (Object.keys(MARKET_ALIASES) as MarketKey[]).find((key) =>
    MARKET_ALIASES[key].includes(normalized),
  );

  return match ?? null;
}

export function getMarketData<T>(
  marketParam: string | undefined,
  map: Partial<Record<MarketKey, T>>,
): T | null {
  const marketKey = resolveMarketKey(marketParam);

  if (!marketKey) {
    return null;
  }

  return map[marketKey] ?? null;
}
